import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text = 'QUIERO MI ACCESO AHORA',
  className = '',
  onClick
}) => {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`group relative inline-flex items-center justify-center gap-3 bg-gradient-fuchsia text-white px-8 py-4 rounded-full font-bold text-lg tracking-wide shadow-glow hover:shadow-soft transition-all duration-300 ${className}`} data-id="element-72">
      <span data-id="element-73">{text}</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-74" />
    </motion.button>;
};